// extracted by css-extract-rspack-plugin
export default {"container":"container__gnN43","card":"card__QUuj5","title":"title__V8kMG","text":"text__XSWzN","actions":"actions__LTzSA","hint":"hint__D8zEb"};